// extracted by mini-css-extract-plugin
export var authors = "fellowshipHeader-module--authors--757eb";
export var container = "fellowshipHeader-module--container--238c2";
export var createdDate = "fellowshipHeader-module--createdDate--4decc";
export var credit = "fellowshipHeader-module--credit--a6650";
export var feature = "fellowshipHeader-module--feature--29f7c";
export var featuredImage = "fellowshipHeader-module--featuredImage--42ed0";
export var imageWrap = "fellowshipHeader-module--imageWrap--18c2b";
export var label = "fellowshipHeader-module--label--3708d";
export var slideUp = "fellowshipHeader-module--slideUp--200a3";
export var slideUpLarge = "fellowshipHeader-module--slideUpLarge--30fcb";
export var title = "fellowshipHeader-module--title--825da";
export var videoContainer = "fellowshipHeader-module--videoContainer--7b3a3";
export var wrap = "fellowshipHeader-module--wrap--92317";
export var youtubeWrap = "fellowshipHeader-module--youtubeWrap--d90b6";